import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { HotelCardTag } from '@lt/components';
import { TYPES } from '@lt/components/components/HotelCardTag/utils/tagTypes';

import OperatorInfoContainer from '../../OperatorInfo';
import {
  SearchParamsDatesContainer,
  SearchParamsNightsContainer,
  SearchParamsTouristsContainer,
} from '../../SearchParams';
import {
  Experiment,
  EXPERIMENT_NAMES,
  Variant,
} from '../../../../../components/Experiment';

const baseCls = 'checkout-shortinfo';

interface SearchParamsProps {
  hasAdjustParams: boolean;
  instantConfirm: boolean;
  isMobile: boolean;
  isArchived: boolean;
}

const SearchParams = ({
  hasAdjustParams,
  instantConfirm,
  isMobile,
  isArchived,
}: SearchParamsProps): JSX.Element => {
  const { t } = useTranslation();

  const tagBody = TYPES.instantConfirm;
  const tagTooltip = tagBody.tooltipText;

  return (
    <div className={baseCls}>
      <div className={`${baseCls}__top`}>
        {!isArchived && hasAdjustParams && (
          <span className="checkout-searcher__title">
            {t('checkout.search.title')}
          </span>
        )}
        {instantConfirm && !hasAdjustParams && (
          <HotelCardTag
            type="instantConfirm"
            text={t('checkout.search.instant')}
            tagTooltip={tagTooltip}
          />
        )}
        {!isMobile && !isArchived && (
          <Experiment name={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.NAME}>
            <Variant
              option={EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES.OPTIONS.OFF}
            >
              <OperatorInfoContainer
                className={`${baseCls}__top-operator_text`}
              />
            </Variant>
          </Experiment>
        )}
      </div>

      <ul
        className={cn(`${baseCls}__block`, {
          [`${baseCls}__block--offset`]: hasAdjustParams,
        })}
      >
        <SearchParamsDatesContainer isArchived={isArchived} />
        <SearchParamsNightsContainer isArchived={isArchived} />
        <SearchParamsTouristsContainer isArchived={isArchived} />
      </ul>
    </div>
  );
};

export default SearchParams;
